module.exports = __webpack_public_path__ + "static/media/workcom-landscape.acfd22be.jpg";